import { createStore } from 'redux';
import rootReducer from './ducks/root';

const store = createStore(rootReducer);

if (typeof window !== 'undefined') window.store = store;
export default store;
